//component 注册---
// import 'babel-polyfill'
import Datepicker from './datepicker.vue'
import Slide from './slide.vue'
import Tooltips from './tooltips.vue'
import Popover from './popover.vue'
import Tree from './tree.vue'
import TreeItem from './treeItem.vue'
import TreeSelect from './treeSelect.vue'
import Dialog from './dialog.vue'
import Tab from './tab.vue'
import Form from './form.vue'
import FormItem from './formItem.vue'

import Tips from './tips.vue'
import { Table, TableColumn} from 'element-ui'
import Select from './select.vue'
import Dropdown from './dropdown.vue'
import AutoComplete from './autoComplete.vue'
import Step from './step.vue'
import Scrollbar from './scrollbar/index'
import popoverDirective from './directives/popover.js'
import Page from './pagination.vue'
import Email from './email.vue'



const components = [
	Datepicker,
	Slide,
	Tooltips,
	Tree,
	TreeItem,
	TreeSelect,
	Dialog,
	Tab,
	Form,
	FormItem,
	Tips,
	Select,
	Dropdown,
	AutoComplete,
	Step,
	Popover,
	Scrollbar,
	Page,
	Email
]




var install = function(Vue) {
	if (install.installed) return;
	
	//console.log('begin install hz components:', Vue);
	// var components = ['datepicker', 'progress', 'slide', 'toggle', 'tooltips', 'tree', 'treeSelect',
	// 	'treeView', 'error', 'dialog', 'tab', 'form', 'formItem', 'tips', 'table', 'select', 'dropdown', 'autoComplete', 'step'];
	window.hz._components = {}
	components.map(function(one) {
		Vue.component(one.name, one);
		window.hz._components[one.name] = one;
	});

	Vue.component('hz-table', Table);
	Vue.component('hz-table-column', TableColumn);
	Vue.directive('hz-popover', popoverDirective);

	console.log('hz components installed');

	Vue.prototype.hz = window.hz;
}

//js工具
;(function(){
	window.hz = {};
	hz.ajax = require('./js/ajax').default;
 	hz.algorithm = require('./js/algorithm').default;
 	hz.localStorage = require('./js/localStorage').default;
 	hz.date = require('./js/date').default;
 	hz.week = require('./js/week').default;
 	hz.location = require('./js/location').default;
 	hz.dialog = require('./js/dialog').default;
 	hz.tools = {
 		obj: require('./js/object').default,
 		data: require('./js/data').default,
 		csv: require('./js/csv').default,
 		number: require('./js/number').default,
 		form: require('./js/form').default,
 		string: require('./js/string').default,
 		enum: require('./js/enum').default,
 		table: require('./js/toolstable').default,
 		browser: require('./js/browser').default
	 };
	hz.notify = require('./js/notification.js').default;
 	hz.install = install;
})();


if (typeof window !== 'undefined' && window.Vue) {
  	install(window.Vue);
}
else {
	console.log('no vue found in window');
}

import './css/index.styl'
import './css/table.css'
import './css/table-column.css'

export default { 
	install: install
}


// WEBPACK FOOTER //
// ./src/index.js